import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from 'common/components/layout';
import Banner from 'modules/help/components/Banner';
import TopicList from 'modules/help/components/TopicList';
import FAQ from 'common/components/UI/faq/FAQ';
import ContactBanner from 'common/components/banners/Contact-Banner';
import { baseApiUrl } from 'common/utils/constants';

const HelpCenter = ({
  topics,
  posts,
}: {
  topics: Data<Category[]>;
  posts: Data<News[]>;
}) => {
  const { query } = useRouter();
  const [hasLayout, setHasLayout] = useState<boolean>(true);

  useEffect(() => {
    if (query.header === '0') setHasLayout(false);
  }, [query.header]);

  return (
    <>
      <Head>
        <title>Apollon Help Centre - Apollon</title>
        <meta
          name='description'
          content="Discover how Apollon stands out with our Help Centre. Find answers to your questions and learn more about our services. Use our FAQ page and search box to get the help you need."
        />
      </Head>
      <Layout
        mainClassName='pb-0'
        showFooter={hasLayout}
        showHeader={hasLayout}
      >
        <Banner />
        <TopicList data={topics.items} />
        <FAQ line={true} title='Frequently asked questions' data={posts} />
        <ContactBanner />
      </Layout>
    </>
  );
};

export default HelpCenter;

export async function getStaticProps() {
  try {
    const resTopics = await fetch(
      baseApiUrl + `/categories?type=faq&ordering=top-view`
    );
    const resPosts = await fetch(
      baseApiUrl + `/posts?categoryType=faq&ordering=top-view`
    );
    const PostsData = await resPosts.json();
    const TopicsData = await resTopics.json();

    if (!PostsData || !TopicsData) {
      throw new Error('Data is empty');
    }

    // Pass data to the page via props
    return { props: { topics: TopicsData.data, posts: PostsData.data } };
  } catch (error) {
    console.error('Failed to fetch data:', error);
    return { props: { topics: [], posts: [] } }; // Fallback to an empty array in case of error
  }
}
